
import {
  getSelectStakeholders,
  getSelectAims,
  getSelectCriterions,
  state,
  getAllItems,
  orderByPropName,
  getSelectModes,
  loadAll,
  switchToView,
  is1stLevelStakeholdersMode,
} from "@/store";
import { debounce } from "lodash";
import { computed, defineComponent } from "vue";
import HeaderMenu from "@/components/HeaderMenu.vue";

export default defineComponent({
  components: {
    HeaderMenu,
  },
  setup() {
    return {
      state,

      clearSearch: () => {
        state.searchInput = "";
      },

      debounceInput: debounce((value) => {
        state.searchInput = value;
      }, 200),

      orderByPropName,
      is1stLevelStakeholdersMode,
      getSelectStakeholders: computed(() => getSelectStakeholders()),
      getSelectAims: computed(() => getSelectAims()),
      getSelectCriterions: computed(() => getSelectCriterions()),
    };
  },
});
